<template>
    <div class="game-settings">
            <div class="game-help">
                <i class="far fa-question-circle" @click="openHelp()"></i>
            </div>
            <div class="game-name">
                {{matchtypename}}
            </div>
            <template v-if="sensor !== 1">
            <div class="game-setting" v-for="item in game.options" v-bind:key="item.name">
                <div class="option">{{__('matchform.' + String(item.name)).replace("matchform.","")}}</div>
                <div class="value">{{__(String(item.value)).replace("matchform.","")}}</div>
            </div>
            </template>
            <template v-else>
                <div class="sensoractive">
                    <div class="sensoractiveMain">
                        <h1>{{__('games.sensor_active')}}</h1>
                    </div>
                </div>
            </template>

            <div class="abort-game" @click.prevent="leaveGame()">
                <a href="#" title="Spiel abbrechen"><i class="fas fa-times-circle"></i></a>
            </div>

            <div class="clear-throw" @click.prevent="clearThrow()">
                <a href="#" title="Wurf neu"><i class="fas fa-undo"></i></a>
            </div>
            <div :class="['webcam-toggle', this.webcamsOn ? '' : 'off']"  @click.prevent="toggleWebcams()" title="Webcams ein/ausschalten">
                <a href="#">
                    <svg style="width:24px;height:24px;margin-top: -4px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M12,2A7,7 0 0,1 19,9A7,7 0 0,1 12,16A7,7 0 0,1 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9A5,5 0 0,0 12,14A5,5 0 0,0 17,9A5,5 0 0,0 12,4M12,6A3,3 0 0,1 15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6M6,22A2,2 0 0,1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20A2,2 0 0,1 18,22H6Z" />
                    </svg>
                </a>
            </div>
            <!-- <div :class="['sensor', sensor == 1 ? 'on' : sensor == 2 ? 'off' : 'd-none']">
                <a href="#"><i :class="[sensor == 1 ? 'far fa-eye' : 'fas fa-eye-slash']"></i></a>
            </div> -->

            <div :class="['microphone', microphone ? 'on' : 'off']"  @click.prevent="toggleMicrophone()" v-if="microphoneStreamCheck()">
                <a href="#"><i :class="['fas', microphone ? 'fa-microphone' : 'fa-microphone-slash']"></i></a>
            </div>

            <!-- <div :class="['volume', audioVolumeOn() ? '' : 'off']">
                <a href="#" @click.prevent="toggleAudioVolume()"><i :class="['fas', audioVolumeOn() ? 'fa-volume-up' : 'fa-volume-mute']"></i></a>
            </div> -->
        <game-asset-audio-player></game-asset-audio-player>
        <b-modal id="modal-help" :title="__('games.help')">
            <template #default>
                <template v-if="help != null && help != 'no_help_available'">
                    <div v-html="help"></div>
                </template>
                <template v-else>
                    <h1>Hilfe zum Spiel</h1>
                    <p>Die Hilfe wird gerade geschrieben und ist in wenigen Tagen verf&uuml;gbar.</p>
                </template>
            </template>
        </b-modal>
    </div>
</template>

<script>
import gameAssetAudioPlayer from "./gameAssets/gameAssetAudioPlayer.vue"

    export default {
        components: { gameAssetAudioPlayer },
        props: ['game', 'matchtypename', 'logged_in_user'],
        mixins: [],
        data() {
            return {
                webcamsOn: true,
                profile: null,
                sensor: 0,
                microphone: true,
                help: null,
            }
        },
        mounted() {
            this.$root.$emit('ProfileSelectorAddObserver', this.loadProfile)

            this.$root.$on('ViewerWebcamsToggledOn', () => {this.webcamsOn = true});
            this.$root.$on('ViewerWebcamsToggledOff', () => {this.webcamsOn = false});

            window.connection.subscribeSensor(this);
            this.update(window.connection.lastSensorUpdate);
            window.connection.subscribe(this);
            this.update(window.connection.lastUpdate);

            axios.get("/help/"+this.matchtypename).then((returnData) => {
                this.help = returnData.data;
            })
        },
        methods: {
            update(data) {
                if (data == null) return;
                if (data.sensor !== undefined && data.user_id == this.logged_in_user)
                    this.sensor = data.sensor;
                if (this.sensor == 1) {
                    if(document.getElementById("maincontainer"))
                        document.getElementById("maincontainer").classList.add("sensorglow");
                } else {
                    if(document.getElementById("maincontainer"))
                        document.getElementById("maincontainer").classList.remove("sensorglow");
                }
            },
            loadProfile(profile) {
                this.profile = profile;
                this.webcamsOn = this.profile.autostart_webcams == 1;
            },
            toggleWebcams() {
                this.webcamsOn = !this.webcamsOn;
                // if (this.webcamsOn) this.$root.$emit('ViewerWebcamsToggleOn')
                // if (!this.webcamsOn) this.$root.$emit('ViewerWebcamsToggleOff')
                axios.post("/games/sendusercommand", {event: "webcam", args: {value: this.webcamsOn}})
            },
            toggleMicrophone() {
                this.microphone = !this.microphone;
                axios.post("/games/sendusercommand", {event: "microphone", args: {value: this.microphone}})
            },
            microphoneStreamCheck() {
               return true //TODO: add user preference here
            },
            leaveGame() {
                if (window.confirm("Willst du das Spiel wirklich verlassen?")) {
                    axios.post("/games/" + this.game.id + "/exit", {player: window.player.id}).then(() => {
                        window.location.href = "/matchrequests/";
                    })

                }
            },
            clearThrow() {
                axios.post("/api/sendNumpadCommand", { command: "clear" }).then((e) => {
                });
            },
            openHelp() {
                this.$bvModal.show('modal-help');
            }
        }
    }
</script>

<style scoped>

    .sensoractive {
        display: block;
        background-color: #d61445;
        width: auto;
        padding: 0 1em;
    }

    .sensoractiveMain h1 {
        font-size: 1.5em;
        text-align: center;
        color: var(--white);
        line-height: 1em;
        padding-top: 0.2em;
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
        0% {
            opacity: 0;
        }
        25% {
            opacity: 1;
        }
        50% {
            opacity: 1;
        }
        75% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

</style>
